
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {IAntiTheft} from "@/modules/CarList/interfaces/anti-theft.interface";
  import {IApp} from "@/interfaces/app.interface";
  import _ from 'lodash';

  @Component({})
  export default class ScheduleTimesBlock extends Vue {
    @Prop() schedule: IAntiTheft.IScheduleItem;
    @Prop() scheduleActive: boolean;
    @Prop() weekDayText: string[];

    dateFormats = IApp.DateFormats;
    openedMore = false;

    get hasMoreValue() {
      let hasValue = false;
      this.schedule.times.forEach((times, index) => {
        if (index > 0 && Boolean(times[0]) && Boolean(times[1])) hasValue = true;
      });
      return hasValue;
    }

    changeValue(value: string, i: number, j: number) {
      let times = _.cloneDeep(this.schedule.times);
      times[i][j] = value;

      this.$emit('changeValue', times);
    }

    clearDate(i: number, j: number) {
      this.$emit('clearDate', { i, j });
    }
  }
